var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cost-mapping"
  }, [_c('div', {
    staticClass: "flex justify-between items-center pb-6 shadow-border-b gap-8 mdmax:gap-2 mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 mdmax:flex-auto mdmax:w-full"
  }, [_c('LinkButton', {
    attrs: {
      "buttonText": "Tambah Cost Mapping",
      "url": "/package/cost-mapping/create",
      "linkType": "internal",
      "size": _vm.isMobile ? 'full' : 'regular'
    }
  })], 1), _c('div', {
    staticClass: "flex-1 flex justify-end gap-8 mdmax:flex-auto mdmax:w-full mdmax:justify-start"
  }, [_c('div', {
    staticClass: "w-3/5 mdmax:w-full"
  }, [_c('label', {
    staticClass: "text-base text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Pencarian")]), _c('div', {
    staticClass: "relative"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "withIcon": true,
      "placeholder": "Cari pemetaan biaya"
    },
    on: {
      "enter": _vm.doSearch
    },
    model: {
      value: _vm.searchTerm,
      callback: function ($$v) {
        _vm.searchTerm = $$v;
      },
      expression: "searchTerm"
    }
  }), _c('div', {
    staticClass: "absolute left-3 top-1/2 transform -translate-y-1/2"
  }, [_c('Search')], 1)], 1)])])]), _c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.filteredData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'action' ? _c('div', {
          staticClass: "flex gap-3 items-center"
        }, [_c('router-link', {
          staticClass: "inline-block cursor-pointer",
          attrs: {
            "to": `/package/cost-mapping/detail/${entry.id}`
          }
        }, [_c('EyeOpen', {
          attrs: {
            "color": "neutral-700"
          }
        })], 1), _c('router-link', {
          staticClass: "inline-block cursor-pointer",
          attrs: {
            "to": `/package/cost-mapping/detail/${entry.id}/update`
          }
        }, [_c('Pencil', {
          attrs: {
            "color": "neutral-700"
          }
        })], 1), _c('router-link', {
          staticClass: "inline-block cursor-pointer",
          attrs: {
            "to": `/package/cost-mapping/detail/${entry.id}/duplicate`
          }
        }, [_c('Copy', {
          attrs: {
            "color": "neutral-700"
          }
        })], 1), _c('span', {
          staticClass: "inline-block cursor-pointer",
          on: {
            "click": function ($event) {
              return _vm.toggleCMDeleteConfirmation(entry.id);
            }
          }
        }, [_c('Trash', {
          attrs: {
            "color": "neutral-700"
          }
        })], 1)], 1) : column.field === 'id' ? _c('span', {
          staticClass: "block break-all",
          attrs: {
            "title": entry.id
          }
        }, [_vm._v(" " + _vm._s(entry.id) + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field]))])];
      }
    }])
  }), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-center items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e(), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleCMDeleteConfirmation,
      "width": "600px",
      "id": "delete-confirmation-modal"
    },
    on: {
      "close": function ($event) {
        return _vm.toggleCMDeleteConfirmation();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex items-center justify-start gap-6 mb-6"
  }, [_c('span', {
    staticClass: "flex-shrink-0"
  }, [_c('Alert', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('div', {
    staticClass: "flex-col flex gap-2 items-start"
  }, [_c('p', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v("Hapus Cost Mapping?")]), _c('p', {
    staticClass: "text-sm text-neutral-500 text-left"
  }, [_vm._v(" Menghapus cost mapping akan berpengaruh terhadap layanan dan tidak bisa dibisa di kembalikan. pastikan cost mapping yang akan di buat tidak terkoneksi dengan layanan apapun ")])])]), _c('div', {
    staticClass: "flex justify-end gap-6"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Tidak",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleCMDeleteConfirmation();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Ya",
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.confirmCMDelete();
      }
    }
  })], 1)])], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }